export enum ApiRequestType {
	UNIFIED_GUEST_LOGIN = 'UnifiedGuestLogin',
	GET_UNIFIED_ORDER_TICKET_TYPE = 'GetUnifiedOrderTicketType',
	PAYMENT_PORTAL_LOGIN = 'PaymentPortalLogin',
	GUEST_VIEW_ORDER = 'GuestViewOrder',
	GET_MERCHANT_DETAILS = 'GetMerchantDetails',
	CHANGE_CARD = 'ChangeCard',
	UPDATE_BILLING_INFO = 'UpdateBillingInfo',
	GUEST_ORDER_SEARCH = 'GuestOrderSearch',
	CANCEL_MEMBERSHIP = 'CancelMembership',
	CHANGE_CUSTOMER_EMAIL = 'ChangeCustomerEmail',
	EMAIL_RECEIPT = 'EmailReceipt',

	// Booking Portal
	BOOKING_PORTAL_LOGIN = 'BookingPortalLogin',
	GET_EVENT_DATES_BY_CALENDAR = 'GetEventDatesByCalendar',
	ADD_EDIT_BOOKING = 'AddEditBooking',
	EMAIL_ITINERARY = 'BookingConfirmationEmail',
	GET_ENTITLEMENT_KEYWORD_CALENDAR = 'GetEntitlementKeywordCalendar',

	// Cart
	GET_DYNAMIC_PRICING_ADJUSTMENT = 'GetDynamicPricingAdjustment',
	ADD_CART_ITEM = 'AddCartItem',
	UPDATE_CART_ITEMS = 'UpdateCartItems',
	GET_NEW_CART_ID = 'GetNewCartID',
	GET_CART_SUMMARY = 'GetCartSummary',

	// Core
	GET_APPLICATION_CONFIG = 'GetApplicationConfig',
	GET_PAYMENT_CONFIGURATION = 'GetPaymentConfiguration',
	GET_APPLICATION_LOCALE = 'GetApplicationLocale',
	GET_ACCESSO_PAY_SESSION = 'GetAccessoPaySession',
	CREATE_ACCESSO_PAY_SESSION = 'CreateAcessoPaySession',
	ACCESSO_PAY_SESSIONS = 'accesso-pay-sessions',

	// Alternate Payments
	INITIATE_ALT_PAY = 'InitiateAltPay',
	UPDATE_ALT_PAY = 'UpdateAltPay',

	// Cybersource
	CREATE_JWK = 'CreateJwk',
	CREATE_CARDINAL_JWT = 'createjwt',

	// 3D Secure
	ENROLLMENT_CHECK_3DS = 'enrollmentCheck3DS',
	VALIDATE_3DS = 'validate3DS',

	// Card Capture
	AUTHORIZE = 'Authorize',

	// Refresh MFA
	REFRESH_MFA = 'RefreshMfa',

	// Rebuild MFA
	REBUILD_MFA_FOR_ORDER = 'RebuildMfaForOrder',

	// Contract Viewer
	GET_ORDER_FORM_INFO = 'GetOrderFormInfo',
}

export type StringOrNumber = string | number;

export type TrueOrFalse = 'true' | 'false';
